import { SERVICE_TYPES, HTTPError, type MatrixClient, type Terms } from "matrix-js-sdk/src/matrix";
import { logger } from "matrix-js-sdk/src/logger";

import SdkConfig from "../SdkConfig";

export function getDefaultIdentityServerUrl(): string | undefined {
    return SdkConfig.get("validated_server_config")?.isUrl;
}

export function setToDefaultIdentityServer(matrixClient: MatrixClient): void {
    const url = getDefaultIdentityServerUrl();
    // Account data change will update localstorage, client, etc through dispatcher
    matrixClient.setAccountData("m.identity_server", {
        base_url: url ?? null,
    });
}

export async function doesIdentityServerHaveTerms(matrixClient: MatrixClient, fullUrl: string): Promise<boolean> {
    let terms: Partial<Terms> | null;
    try {
        terms = await matrixClient.getTerms(SERVICE_TYPES.IS, fullUrl);
    } catch (e) {
        logger.error(e);
        if (e instanceof HTTPError && e.httpStatus === 404) {
            terms = null;
        } else {
            throw e;
        }
    }

    return !!terms?.["policies"] && Object.keys(terms["policies"]).length > 0;
}

export function doesAccountDataHaveIdentityServer(matrixClient: MatrixClient): boolean {
    const event = matrixClient.getAccountData("m.identity_server");
    return event?.getContent()["base_url"];
}
